/**
 * Parses a string into a float.
 * @param {string} numberToParse string to be parsed as float
 */
const parseFloatValue = (numberToParse) => {
    //return parseFloat(numberToParse).toFixed(2).replace('.', ',')
    return parseFloat(numberToParse).toLocaleString('de-DE', { maximumFractionDigits: 2, minimumFractionDigits: 2 })
}

/**
 * Parses a string into a float including a currency symbol
 * @param {any} numberToParse string to be parsed as float currency
 */
const parseFloatCurrency = (numberToParse) => {
    //return parseFloat(numberToParse).toFixed(2).replace('.', ',') + "€"
    return parseFloat(numberToParse).toLocaleString('de-DE', { maximumFractionDigits: 2, minimumFractionDigits: 2 }) + "€"
}

export { parseFloatValue, parseFloatCurrency }